module.exports = __webpack_public_path__ + "img/Square_mobile-screenshot.9fe36883.png";